import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Login.css";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { CreateOTP, OTPReset } from "../Redux/OTPRedux";
import { SubmitLogin } from "../Redux/LoginRedux";

function Login(props) {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.OTP);
  const posts2 = useSelector((state) => state.Login);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleOTP = () => {
    const errors = {};
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      dispatch(CreateOTP({ Email: formData.email }));
    }
  };

  const handleSubmit = () => {
    const errors = {};
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
    }

    if (!formData.otp.trim()) {
      errors.otp = "OTP is required";
    } else if (formData.otp.length < 6 || formData.otp.length > 6) {
      errors.otp = "OTP is of 6 Character";
    }

    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      dispatch(SubmitLogin({ Email: formData.email, otp: formData.otp }));
    }
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="sm">
      <Modal.Header
        closeButton
        className="Titel03"
        onClick={() => {
          dispatch(OTPReset());
          setErrors({});
        }}
      >
        <Modal.Title id="contained-modal-title-vcenter">Login</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ArtBox03">
        <div className="input-group  mb-3 SearchIP02">
          <input
            type="email"
            className="form-control"
            name="email"
            placeholder="Email Address"
            id="EmailAddressLogin"
            onChange={handleChange}
          ></input>
        </div>
        {errors.email && (
          <div className=" d-flex justify-content-center ">
            <p> {errors.email}</p>
          </div>
        )}
        <div className="input-group  mb-3 ">
          <button
            className="Button05"
            type="button"
            id="button-addon2"
            onClick={handleOTP}
          >
            Send OTP
          </button>
          <input
            type="text"
            className="form-control"
            name="otp"
            placeholder="OTP"
            aria-label="Recipient's username"
            aria-describedby="button-addon2"
            onChange={handleChange}
          ></input>
        </div>
        {errors.otp && (
          <div className=" d-flex justify-content-center ">
            <p> {errors.otp}</p>
          </div>
        )}
        <div
          className={posts.OTPResponce[0] + " d-flex justify-content-center "}
        >
          <p>{posts.OTPResponce[1]}</p>
        </div>
        <div
          className={
            posts2.LoginResponce[0] + " d-flex justify-content-center "
          }
        >
          <p>{posts2.LoginResponce[1]}</p>
        </div>

        <Button className="Button04" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default Login;
